<template>
  <article
    class="flex flex-col sm:flex-row w-full sm:gap-12 items-center p-4 shadow-md rounded border-l-4 border-h-primary-800"
  >
    <img
      :src="course.file?.url"
      :alt="course.name"
      class="w-[123px] min-w-[123px] h-[73px] object-cover rounded"
      @emptied="`@/assets/images/image-default.svg`"
    />
    <p class="flex-[53%] text-h-neutral-900">{{ course.name }}</p>
    <p
      class="rounded-2xl text-center py-[2.5px] w-[78px] px-2 text-xs"
      :class="[
        {
          'text-white bg-h-primary-500': course.type !== CourseType.ADAPTATIVE,
        },
        {
          ' text-h-neutral-50 bg-h-secondary-600':
            course.type === CourseType.ADAPTATIVE,
        },
        {
          'text-black bg-h-secondary-200':
            course.type === CourseType.INTERACTIVE,
        },
      ]"
    >
      {{ labelCourseType }}
    </p>
    <Button
      class="btn-simple gap-2 flex-1 min-w-[183px]"
      @click="redirectToForum"
    >
      <span>
        {{ $t("labels.generic", { pt: "Acessar fórum", en: "Access forum" }) }}
      </span>
      <v-icon name="co-arrow-right" width="24" height="24" />
    </Button>
  </article>
</template>
<script lang="ts">
import { Course, CourseType } from "@/models/courses.model";
import { useCourseStudentStore } from "@/store/course-student";
import { GoToRoute } from "@/utils/go-to.util";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "card-forum",
  props: {
    course: {
      type: Object as PropType<Course>,
      required: true,
    },
  },
  setup() {
    return {
      CourseType,
    };
  },
  methods: {
    redirectToForum(): void {
      const courseName = this.course.name.toLowerCase().replaceAll(" ", "-");
      localStorage.setItem("course-type", JSON.stringify(this.course?.type));
      useCourseStudentStore.setCourseType(this.course?.type!);

      this.go.redirectToPage("forum", {
        courseName: courseName,
        id: this.course.id,
      });
    },
  },
  computed: {
    labelCourseType(): string {
      if (this.course.type === CourseType.ADAPTATIVE) {
        return this.$t("labels.generic", {
          pt: "Adaptativo",
          en: "Adaptative",
        });
      }
      if (this.course.type === CourseType.LINEAR) {
        return this.$t("labels.generic", {
          pt: "Tradicional",
          en: "Traditional",
        });
      }
      return this.$t("labels.generic", { pt: "Interativo", en: "Interactive" });
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
});
</script>
